function resolveMqttConnect() {
  const g = (typeof window !== 'undefined') ? window : {}
  const mod = g.mqtt
  if (!mod) return null
  if (typeof mod === 'function') return mod
  if (mod && typeof mod.connect === 'function') return mod.connect
  return null
}

let client = null
const topicHandlers = new Map()
let connected = false
let lastPacketAt = 0
let watchdogTimer = null
let connectUrl = ''
let connectOptions = {}

function clearWatchdog() {
  if (watchdogTimer) {
    clearInterval(watchdogTimer)
    watchdogTimer = null
  }
}

function startWatchdog() {
  clearWatchdog()
  const keepaliveSec = Number(connectOptions && connectOptions.keepalive) || 60
  const timeoutMs = (keepaliveSec + 10) * 1000
  watchdogTimer = setInterval(() => {
    if (!client) return

    if (!client.connected || client.disconnected) {
      connected = false
      return
    }

    if (typeof navigator !== 'undefined' && navigator && navigator.onLine === false) {
      connected = false
      return
    }

    if (lastPacketAt && Date.now() - lastPacketAt > timeoutMs) {
      connected = false
      try {
        if (typeof client.reconnect === 'function') {
          client.reconnect()
        } else {
          client.end(true)
          client = null
          connect(connectUrl, connectOptions)
        }
      } catch (e) {}
    }
  }, 3000)
}

// 1 连接
function connect(url, options = {}) {
  if (client && client.connected) return client
  if (client) {
    try { client.end(true) } catch (e) {}
    client = null
  }
  clearWatchdog()
  connected = false
  lastPacketAt = Date.now()
  connectUrl = url
  connectOptions = options
  const doConnect = resolveMqttConnect()
  if (!doConnect) throw new Error('MQTT connect function not found from module exports')
  client = doConnect(url, options)
  client.on('connect', () => {
    connected = true
    lastPacketAt = Date.now()
  })
  client.on('reconnect', () => {
    connected = false
    lastPacketAt = Date.now()
  })
  client.on('close', () => {
    connected = false
  })
  client.on('offline', () => {
    connected = false
  })
  client.on('end', () => {
    connected = false
  })
  client.on('error', () => {
    connected = false
  })
  client.on('packetreceive', () => {
    lastPacketAt = Date.now()
  })
  client.on('packetsend', () => {
    lastPacketAt = Date.now()
  })
  client.on('message', (topic, payload, packet) => {
    lastPacketAt = Date.now()
    const data = payload ? payload.toString() : ''
    const handlers = topicHandlers.get(topic)
    if (handlers) {
      handlers.forEach(fn => {
        try { fn(data, packet) } catch (e) {}
      })
    }
  })
  startWatchdog()
  return client
}
// 1 连接
function subscribe(topic, handler, options) {
  console.log('-----链接的主题',topic);
  
  if (!client) throw new Error('MQTT not connected')
  const subOptions = Object.assign({ qos: 2 }, options || {})
  client.subscribe(topic, subOptions)
  if (handler) {
    if (!topicHandlers.has(topic)) topicHandlers.set(topic, new Set())
    topicHandlers.get(topic).add(handler)
  }
}
// 2 订阅并处理消息
function unsubscribe(topic, handler) {
  if (!client) return
  if (handler) {
    const set = topicHandlers.get(topic)
    if (set) {
      set.delete(handler)
      if (set.size === 0) topicHandlers.delete(topic)
    }
  } else {
    topicHandlers.delete(topic)
  }
  client.unsubscribe(topic)
}

// 3 发布消息
function publish(topic, message, options) {
  if (!client) throw new Error('MQTT not connected')
  const payload = typeof message === 'string' ? message : JSON.stringify(message)
  const pubOptions = Object.assign({ qos: 2 }, options || {})
  client.publish(topic, payload, pubOptions)
}

// 4 监听连接事件
function on(event, handler) {
  if (!client) throw new Error('MQTT not connected')
  client.on(event, handler)
}
// 5) 取消订阅（可传具体回调或直接全量）
function off(event, handler) {
  if (!client) return
  if (client.off) client.off(event, handler)
  else client.removeListener(event, handler)
}
// 6) 检测是否已连接
function isConnected() {
  return !!(client && connected && client.connected)
}
// 7) 断开
function disconnect(force = true) {
  if (client) {
    try { client.end(force) } catch (e) {}
    client = null
    connected = false
    lastPacketAt = 0
    clearWatchdog()
    topicHandlers.clear()
  }
}

export default {
  connect,
  subscribe,
  unsubscribe,
  publish,
  on,
  off,
  isConnected,
  disconnect
}




/**

import MQTT from '@/utils/mqtt'

// 1) 连接
MQTT.connect('ws://your-mqtt-host:port/mqtt', {
  username: 'user',
  password: 'pass',
  keepalive: 60,
})

// 2) 监听连接事件
MQTT.on('connect', () => {
  console.log('mqtt connected')
})

// 3) 订阅并处理消息
MQTT.subscribe('hbxc/topic/notice', (msg) => {
  // msg 为字符串，如为 JSON 可自行 JSON.parse(msg)
  console.log('收到消息:', msg)
})

// 4) 发送消息
MQTT.publish('hbxc/topic/notice', { type: 'ping', time: Date.now() })

// 5) 取消订阅（可传具体回调或直接全量）
/*
MQTT.unsubscribe('hbxc/topic/notice', handler)
MQTT.unsubscribe('hbxc/topic/notice')
*/

// 6) 断开
// MQTT.disconnect()

// 
